
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign/agent-approvals",
      function () {
        return require("private-next-pages/sign/agent-approvals.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sign/agent-approvals"])
      });
    }
  